(function () {
    'use strict';

    angular
        .module('adminODDRoutes', [
            'adminODDControllers'
        ])
        .config(router);

    router.$inject = ['$stateProvider'];

    function router($stateProvider) {

        $stateProvider
            .state('admin.odd', {
                url: '/ODD',
                views: {
                    'mainContent@admin': {
                        templateUrl: require('./adminODD.tpl.html'),
                        controller: 'AdminODDController'
                    }
                },
                data: {
                    permissions: { featureRole: 'ODDAdministrationManagement', key: 'Administration', permission: 'CanLaunchEcho' }
                }
            });
    }
})();